import QMoney from '../input/src/money';

export default QMoney;
